import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  DialogProps
} from '@mui/material'

type ConfirmDialogProps = DialogProps & {
  dialogTitle: string
  contentText: string | string[]
  confirmText: string
  cancelText?: string
  onCancel?: () => any
  onConfirm: () => any
}
const ConfirmDialog = ({
  dialogTitle,
  contentText,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  ...dialogProps
}: ConfirmDialogProps) => {
  if (!Array.isArray(contentText)) {
    contentText = [contentText]
  }

  return (
    <Dialog {...dialogProps}>
      <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
      <DialogContent>
        {contentText.map((text, id) => (
          <DialogContentText key={id}>{text}</DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        {cancelText && <Button onClick={onCancel}>{cancelText}</Button>}
        <Button onClick={onConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
